import { createContext, useContext } from 'react';
import type { OfflineMediaRef } from './outboxService';

/**
 * Where a form that captures photos to the device collects what it captured,
 * so the submission can list the media the outbox must upload first. Only the
 * form that will submit through the outbox provides it.
 */
export interface LocalCaptureRegistry {
  register: (media: OfflineMediaRef) => void;
}

export const LocalCaptureContext = createContext<
  LocalCaptureRegistry | undefined
>(undefined);

export const useLocalCapture = (): LocalCaptureRegistry | undefined =>
  useContext(LocalCaptureContext);
